import React, { SyntheticEvent } from 'react';

import { useTrackSelect, useTrack } from '@app/analytics';

import { useOptionalField } from './FormikFields';
import { Colors } from '@app/theme';
import { TextAndImageSelectionBlock } from './TextAndImageSelectionBlock';

interface Props {
  illustration?: string;
  title: string;
  description?: string;
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  centerChip?: {
    label: string;
    color: Colors | undefined;
  };
  topChip?: {
    label: string;
    color: Colors | undefined;
    position?: 'center' | 'right';
  };
  isCompact?: boolean;
  trackingName?: string;
  horizontal?: boolean;
}

export const TextAndImageSelectionField = ({
  name,
  value,
  checked,
  disabled,
  trackingName,
  horizontal = false,
  onChange,
  ...rest
}: Props) => {
  const { field } = useOptionalField({ name });
  const _checked = checked ? checked : value === field.value;

  const track = useTrack();

  const _onChange = useTrackSelect(
    (e: SyntheticEvent<HTMLInputElement>) => {
      if (!disabled) {
        if (field.onChange) {
          field.onChange(e);
        }
        if (onChange) {
          onChange(e.currentTarget.value);
        }
      }
    },
    [field.onChange, track],
  );

  return (
    <TextAndImageSelectionBlock
      {...field}
      onChange={_onChange}
      value={value}
      checked={_checked}
      disabled={disabled}
      horizontal={horizontal}
      trackingName={trackingName}
      {...rest}
    />
  );
};
